import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeBanner from "../HOME/Home-Banner";
import Offers from "../Offers/Offers";
import NavbarComponent from "../HOME/Navbar";
import Footer from "../FOOTER/Footer";
import Brands from "../Brand/Brands";
import ProdDetails from "../ProdDetails/ProdDetails";
import CameraDetails from "../Camera/CameraDetails";
import LaptopDetails from "../Laptop/LaptopDetails";
import TabsDetails from "../Tabs/TabsDetails";
import Cart from "../Cart/Cart";
import Orders from "../Orders/Orders";
import WatchDetails from "../Watch/WatchDetails";
import TVDetails from "../TV/TVDetails";
import Productlist from "../Productlist/Productlist";
import Brought from "../HOME/Brought";
import ProductView from "../Productlist/ProductView";
import Privacypolicy from "../FOOTER/Privacypolicy";
import Termscond from "../FOOTER/Termscond";
import Exchangepolicy from "../FOOTER/Exchangepolicy";
import Cancelpolicy from "../FOOTER/Cancelpolicy";
import Replacementpolicy from "../FOOTER/Replacementpolicy";
import PaymentSuccess from "../Cart/PaymentSuccess";

const Routing = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);


    const authToken = urlParams.get("authToken");
    // const authToken="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2N2I4NDY0Y2IzNjRlMGY1YzVlNTE2YjMiLCJpYXQiOjE3NDE3ODI3NTIsImV4cCI6MTc0MjM4NzU1Mn0.eh2fca1ltZRCZFlD2O354pgSGJ2TfTnEB56iXByz9uM"
    // sessionStorage.getItem("token")

    if (authToken && !sessionStorage.getItem("token")) {
      sessionStorage.setItem("token", authToken);
      window.location.reload(); 
    }
  }, []);

  return (
    <>
      <BrowserRouter>
        <NavbarComponent />
        <Routes>
          <Route path="/" element={<HomeBanner />}></Route>
          <Route path="/offers" element={<Offers />}></Route>
          <Route path="/brands" element={<Brands />}></Route>
          <Route
            path="/product/:category/:slug"
            element={<ProdDetails />}
          ></Route>
          <Route path="/product/camera" element={<CameraDetails />}></Route>
          <Route path="/product/laptop" element={<LaptopDetails />}></Route>
          <Route path="/product/tablets" element={<TabsDetails />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/payment-details" element={<PaymentSuccess />}></Route>
          <Route path="/orders" element={<Orders />}></Route>
          <Route
            path="/product/smarts-watch"
            element={<WatchDetails />}
          ></Route>
          <Route path="/product/tv" element={<TVDetails />}></Route>
          <Route path="/product" element={<ProductView />}></Route>
          <Route path="/product1" element={<Productlist />}></Route>
          <Route path="/buy-together" element={<Brought />}></Route>
          <Route path="/privacy-policy" element={<Privacypolicy />}></Route>
          <Route path="/terms-&-conditions" element={<Termscond />}></Route>
          <Route path="/exchange-policy" element={<Exchangepolicy />}></Route>
          <Route path="/cancellation-policy" element={<Cancelpolicy />}></Route>
          <Route
            path="/return-policy"
            element={<Replacementpolicy />}
          ></Route>
           <Route path="/product/:category" element={<ProductView />}></Route>
        </Routes>
        <Footer />
      
      </BrowserRouter>
    </>
  );
};

export default Routing;
